export default __webpack_public_path__ + "static/media/Scroll down.0269c681.svg";